/* eslint-disable @typescript-eslint/no-explicit-any */
import type { ComponentProps, ComponentType, PropsWithChildren } from 'react';

type Provider = 
| ComponentType<PropsWithChildren> 
| [ComponentType<PropsWithChildren>, Record<string, unknown>];

export const withProviders =(...providers: Provider[]) =>
  (WrappedComponent: ComponentType<any> | ((props: ComponentProps<any>) => JSX.Element)) =>
    (props: Record<string, unknown>) =>
      providers.reduceRight(
        (acc, prov) => {
          const Provider = Array.isArray(prov) ? prov[0] : prov;
          const providerProps = Array.isArray(prov) ? prov[1] : {};

          return <Provider {...providerProps}>{acc}</Provider>;
        },
        <WrappedComponent {...props} />
      );
